import {
  defaultLocale,
  localeDetection,
  localePrefix,
  locales,
  pathnames,
} from './locale'

import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix,
  pathnames,
  localeDetection,
})

// 导出类型
export type Locale = (typeof locales)[number]

// 导出语言名称映射
export const languageNames: Record<Locale, string> = {
  en: 'English',
  zh: '简体中文',
  de: 'Deutsch',
  // tw: '繁體中文',
  // ja: '日本語',
  // ko: '한국어',
}

// 重新导出默认值
export { defaultLocale, locales }
